export const PARAMETERS = [
  'webcam',
  'gmaAlarm',
  'tt',
  'td',
  'freezing_tt',
  'freezing_tt2',
  'tb0',
  't5',
  'tg0',
  'tg5',
  'tg5_2',
  'tg10',
  'tg20',
  'tg30',
  'tg30_2',
  'tg50',
  'tg100',
  'road_tt',
  'road_tt2',
  'road_tt3',
  'road_tt4',
  'road_tt5',
  'road_tt6',
  'road_tt7',
  'road_tt8',
  'road_tt9',
  'road_tt10',
  'road_tt11',
  'road_tt12',
  'road_condition',
  'road_condition2',
  'road_condition3',
  'road_condition4',
  'road_condition5',
  'road_condition6',
  'road_condition7',
  'road_condition8',
  'road_condition9',
  'road_condition10',
  'road_condition11',
  'road_condition12',
  'rh',
  'rrr',
  'rrr_day',
  'rrr_week',
  'rrr_month',
  'rrr_year',
  'rr',
  'r_avail',
  'r_intensity',
  'r_type',
  'ww',
  'snow_height',
  'dd',
  'ff',
  'ddg',
  'ffg',
  'fg',
  'wft',
  'salt',
  'salt2',
  'ss1',
  'vis',
  'vv',
  'ppp',
  'qfe',
  'road_grip',
  'n',
  'hcl',
  'humidityIndex',
  'inversionIndex',
  'cond',
];
